/* ==========================================================================
   Royal Care Professional — home section behaviour

   Deliberately small. Add-to-cart runs through Horizon's own
   product-form-component, and the FAQ uses native <details>, so the only
   behaviour left to own here is the wishlist toggle.

   Idempotent: init() only claims nodes it has not seen, so the theme editor
   can re-run it on every section load.
   ========================================================================== */

(function () {
  'use strict';

  if (window.RCSections) {
    window.RCSections.init();
    return;
  }

  var STORAGE_KEY = 'rc-wishlist';

  function read() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function write(ids) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (e) {
      /* private mode — the toggle still works for this page view */
    }
    // rc-header.js listens for this and repaints the header badge.
    document.dispatchEvent(new CustomEvent('rc:wishlist:updated'));
  }

  function paint(button, active) {
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function initWishlist(scope) {
    var saved = read();

    Array.prototype.forEach.call(scope.querySelectorAll('[data-rc-wish]'), function (button) {
      if (button.dataset.rcInit === 'true') return;
      button.dataset.rcInit = 'true';

      var id = button.getAttribute('data-product-id');
      if (!id) return;

      paint(button, saved.indexOf(id) !== -1);

      button.addEventListener('click', function () {
        var ids = read();
        var at = ids.indexOf(id);
        var active = at === -1;

        if (active) {
          ids.push(id);
        } else {
          ids.splice(at, 1);
        }

        paint(button, active);
        write(ids);
      });
    });
  }

  /** Keeps every card for the same product in sync, including other tabs. */
  function resync() {
    var saved = read();
    Array.prototype.forEach.call(document.querySelectorAll('[data-rc-wish]'), function (button) {
      var id = button.getAttribute('data-product-id');
      if (id) paint(button, saved.indexOf(id) !== -1);
    });
  }

  var RCSections = {
    init: function (root) {
      initWishlist(root || document);
      resync();
    }
  };

  window.RCSections = RCSections;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      RCSections.init();
    });
  } else {
    RCSections.init();
  }

  document.addEventListener('rc:wishlist:updated', resync);

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) resync();
  });

  document.addEventListener('shopify:section:load', function (event) {
    RCSections.init(event.target);
  });

  /*
   * Quick add builds its modal by morphing the product page's markup in, which
   * fires no Shopify event and no page load — so the wishlist button that
   * arrives with it would never be claimed. One observer on the modal shell
   * catches every open. init() is idempotent, so re-running it is free.
   */
  function watchQuickAdd() {
    var modal = document.getElementById('quick-add-modal-content');
    if (!modal || !window.MutationObserver) return;

    new MutationObserver(function () {
      RCSections.init(modal);
    }).observe(modal, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchQuickAdd);
  } else {
    watchQuickAdd();
  }
})();
